import type { CopilotRec } from '../../executiveintel/framework';

type Props = { recommendations?: CopilotRec[] };

export function AIExecutiveCopilotPanel({ recommendations = [] }: Props) {
  return (
    <div className="space-y-2">
      {recommendations.map((r) => (
        <div key={r.title} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <span className="rounded bg-brand-100 px-1.5 py-0.5 text-xs font-medium text-brand-700 dark:bg-brand-950 dark:text-brand-300">
            {r.capability}
          </span>
          <p className="mt-1 text-sm font-medium">{r.title}</p>
          <p className="mt-0.5 text-xs text-slate-600 dark:text-slate-400">{r.detail}</p>
        </div>
      ))}
    </div>
  );
}
